export default {
      id: "huge-xls-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#huge-xls",
      toString: function () {
        return this.url;
      }
    }